import React, {useEffect, useState} from 'react';
import Layout from "../components/Layout";
import logoDarkMode from "../assets/header-dark.png";
import logoLightMode from "../assets/header-light.png";
import Icon from "@mdi/react";
import {mdiAlertCircle} from "@mdi/js";
import Header from "../components/Header";
import {TaskType} from "../types/Task";
import TaskComponent from "../components/Task";
import {AddressType, findNextStop} from "../types/Address";
import {useManageContext} from "../App";
import NavigationDropdown from "../components/NavigationDropdown";

export default function NextStop() {

    const {isDarkMode, trip} = useManageContext();
    const [address, setAddress] = useState<AddressType | null | undefined>(null);

    useEffect(() => {
        if (trip) {
            setAddress(findNextStop(trip.Address));
        }
    }, [trip]);

    if (typeof trip === "undefined" || typeof address === "undefined") {
        return <div className="main d-flex justify-content-center align-items-center">
            <div className="text-center">
                <img className="mb-3" src={isDarkMode ? logoDarkMode : logoLightMode} alt="CLOUDEX Tracking" style={{maxHeight: 35}}/>
                <div className="d-flex">
                    <div className="alert alert-danger">
                        <Icon path={mdiAlertCircle} size={1}/> <strong>No Trip or Address found!</strong>
                        <p className="mt-2 mb-0">Please make sure you are using the correct url to access your trip.</p>
                    </div>
                </div>
            </div>
        </div>;
    }

    return (
        <Layout>
            <Header>
                <div className="d-flex align-items-center justify-content-end">
                    <NavigationDropdown address={address}/>
                </div>
            </Header>
            <div className="bg-primary-container px-4 pt-4 border-bottom">
                <div dangerouslySetInnerHTML={{__html: address?.FullAddressHtml ?? ''}}></div>
                <div className="pt-4"></div>
            </div>
            {address?.Tasks.filter((Task: TaskType) => Task.TaskCompletedDate === '').map((Task: TaskType) =>
                <TaskComponent key={'task-' + Task.TaskGuid} Task={Task}/>)}
        </Layout>
    );
}